//component
import DateFilter from  '@/components/elements/activityFeed/activityFeedFilters/dateFilter/feed/DateFilter';
import FeedFilter from  '@/components/elements/activityFeed/activityFeedFilters/feedFilters/FeedFilters';
import ActivityFeed from  '@/components/elements/activityFeed/feeds/ActivityFeed';
import DownloadReportButton from  '@/components/elements/activityFeed/elements/DownloadReportButton/DownloadReportButton';

//styling
import "../../../css/activityFeed/activity-feed-full-page.scss";
import "../../../css/activityFeed/elements/filters.scss";



const ActivityFeedPage = () => {  

    return(
        <div className="activity-feed-full-page">
            <h1>Activity Feed</h1>

            <div className='filter-panel'>
                <DownloadReportButton />
                <DateFilter />
                <FeedFilter />
            </div>

            <ActivityFeed isPopOut={false} />
        </div>
    )
}
export default ActivityFeedPage